import { api } from './api'

// Por padrão, tentamos manter o mesmo contrato do dashboard React (GET/PATCH/PUT),
// mas apontando para uma API externa.
const KPI_PATH = '/kpis'
const KPI_BULK_PATH = '/kpis/bulk'

export async function listKpis(params) {
  const res = await api.get(KPI_PATH, { params })
  return res.data?.data ?? res.data
}

export async function updateRealizado(payload) {
  const res = await api.patch(KPI_PATH, payload)
  return res.data?.data ?? res.data
}

/**
 * Atualiza vários valores de "realizado" em uma única chamada.
 *
 * Payload esperado:
 * { items: [{ sector, kpi_name, month, realizado }] }
 *
 * Retorno esperado:
 * - array de rows (mesmo shape do GET /kpis) OU
 * - { data: [...] }
 */
export async function updateRealizadoBulk(payload) {
  const res = await api.patch(KPI_BULK_PATH, payload)
  return res.data?.data ?? res.data
}

export async function upsertKpiMonthly(payload) {
  const res = await api.put(KPI_PATH, payload)
  return res.data?.data ?? res.data
}

/**
 * Atualiza a meta de um mês dividindo entre as 4 semanas (sempre salva por semana).
 * Payload: { year?, sector, kpi_name, month, meta }
 * Envia 4 itens no bulk: week 1..4 com meta = meta/4 cada.
 */
export async function updateMetaMonth(payload) {
  const year = payload.year ?? new Date().getFullYear()
  const sector = payload.sector
  const kpi_name = payload.kpi_name
  const month = payload.month
  const metaTotal = Number(payload.meta) || 0
  const metaPerWeek = Math.round((metaTotal / 4) * 10000) / 10000

  const items = [1, 2, 3, 4].map((week) => ({
    year,
    sector,
    kpi_name,
    month,
    week,
    meta: metaPerWeek,
  }))
  const res = await api.patch(KPI_BULK_PATH, { items })
  return res.data?.data ?? res.data
}

